import { APP_STORE_URL, PLAY_STORE_URL } from "@groupeo/shared";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import logo from "@/src/common/assets/images/logo.png";
import { env } from "@/src/common/constants/env";
import { MARKETING_ROUTES } from "../constants/marketing-routes";

export function SiteFooter() {
	const { t } = useTranslation("marketing");

	return (
		<footer className="border-t border-white/10 pt-10">
			<div className="grid gap-10 text-sm text-white/64 sm:grid-cols-3">
				<div>
					<div className="flex items-center gap-3">
						<img
							src={logo}
							alt={`${env.APP_NAME} icon`}
							width={40}
							height={40}
							loading="lazy"
							decoding="async"
							className="size-10 rounded-2xl"
						/>
						<span className="text-base font-semibold text-white">{env.APP_NAME}</span>
					</div>
					<p className="mt-4 max-w-xs text-sm leading-6 text-white/52">{t("footer_copy")}</p>
				</div>
				<div className="grid grid-cols-2 gap-8 sm:col-span-2 sm:grid-cols-3">
					<nav aria-label={t("footer_col_product")} className="flex flex-col gap-3">
						<p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/40">{t("footer_col_product")}</p>
						<Link to={MARKETING_ROUTES.FEATURES} className="transition-colors hover:text-white">
							{t("nav_features")}
						</Link>
						<Link to={MARKETING_ROUTES.FAQ} className="transition-colors hover:text-white">
							{t("nav_faq_page")}
						</Link>
						<Link to={MARKETING_ROUTES.DOWNLOAD} className="transition-colors hover:text-white">
							{t("nav_download")}
						</Link>
						<a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="transition-colors hover:text-white">
							App Store
						</a>
						<a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" className="transition-colors hover:text-white">
							Google Play
						</a>
					</nav>
					<nav aria-label={t("footer_col_company")} className="flex flex-col gap-3">
						<p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/40">{t("footer_col_company")}</p>
						<Link to={MARKETING_ROUTES.ABOUT} className="transition-colors hover:text-white">
							{t("nav_about")}
						</Link>
						<Link to={MARKETING_ROUTES.CONTACT} className="transition-colors hover:text-white">
							{t("nav_contact")}
						</Link>
					</nav>
					<nav aria-label={t("footer_col_legal")} className="flex flex-col gap-3">
						<p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/40">{t("footer_col_legal")}</p>
						<Link to={MARKETING_ROUTES.PRIVACY} className="transition-colors hover:text-white">
							{t("nav_privacy")}
						</Link>
						<Link to={MARKETING_ROUTES.TERMS} className="transition-colors hover:text-white">
							{t("nav_terms")}
						</Link>
						<Link to={MARKETING_ROUTES.LEGAL_NOTICE} className="transition-colors hover:text-white">
							{t("nav_legal")}
						</Link>
					</nav>
				</div>
			</div>
		</footer>
	);
}
